// eslint-disable-next-line no-unused-vars
import store from '@/store'
// 数字转"万" 过滤器
const numberTextFormat = function (value) {
  if (value !== undefined && value !== null) {
    if (Number(value) < 10000) {
      let str = value.toString()
      return str
    } else {
      let str = Number((Number(value) / 10000).toFixed(2)).toString()
      return str + 'w'
    }
  } else {
    return ''
  }
}

/**
 * 时间过滤器
 * @date 2021-08-23
 * @param {any} 时间/时间戳
 * @param {any} 转换格式
 * @returns {any} 转换好的时间格式
 */
const dateFormat = function (time, fmt) {
  if (!time) {
    return
  }
  fmt = fmt || 'yyyy-MM-dd hh:mm'
  let date = new Date(time)

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }

  let dt = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  }

  for (let key in dt) {
    if (new RegExp(`(${key})`).test(fmt)) {
      let str = dt[key] + ''
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length)
      )
    }
  }

  return fmt
}

/**
 * 查找字典项真实name值
 * @date 2021-08-23
 * @param {String} ConfigCode
 * @returns {String} ConfigName
 */
const dictionaryGetName = function (value) {
  if (!value) return
  const dictionary = store.getters['system/getDictionary'] || []
  let text = dictionary[value] || value
  return text
}

export { numberTextFormat, dateFormat, dictionaryGetName }
